import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Bell, ChevronDown } from 'lucide-react';
import theme from '../theme';

const HeaderContainer = styled(motion.header)`
  background: ${theme.colors.header};
  backdrop-filter: blur(12px);
  border-bottom: 1px solid ${theme.colors.borderLight};
  padding: 16px 24px;
  position: sticky;
  top: 0;
  z-index: 50;
`;

const HeaderContent = styled.div`
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

const Breadcrumb = styled.div`
  font-size: 14px;
  color: ${theme.colors.text.muted};
`;

const BreadcrumbItem = styled.span`
  &:not(:last-child)::after {
    content: '/';
    margin: 0 8px;
    color: ${theme.colors.text.muted};
  }
`;

const BreadcrumbActive = styled.span`
  color: ${theme.colors.text.primary};
  font-weight: 500;
`;

// const SearchContainer = styled.div`
//   position: relative;
//   max-width: 320px;
//   flex: 1;
// `;

// const SearchIcon = styled.div`
//   position: absolute;
//   left: 12px;
//   top: 50%;
//   transform: translateY(-50%);
//   color: ${theme.colors.text.muted};
//   pointer-events: none;
// `;
// const SearchInput = styled.input`
//   width: 100%;
//   padding: 10px 12px 10px 40px;
//   border: 1px solid ${theme.colors.inputBorder};
//   border-radius: 8px;
//   font-size: 14px;
//   background: ${theme.colors.inputBackground};
//   color: ${theme.colors.text.primary};
//   transition: all 0.2s ease;

//   &:focus {
//     outline: none;
//     border-color: ${theme.colors.primary};
//     box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.25);
//   }

//   &::placeholder {
//     color: ${theme.colors.text.muted};
//   }
// `;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const IconButton = styled.button`
  background: none;
  border: none;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  color: ${theme.colors.text.secondary};
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    background: ${theme.colors.navHover};
    color: ${theme.colors.text.primary};
  }
`;

const NotificationBadge = styled.span`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  background: ${theme.colors.danger};
  border-radius: 50%;
  border: 2px solid ${theme.colors.backgroundSolid};
`;

const ProfileButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px 6px 6px;
  background: ${theme.colors.card};
  border: 1px solid ${theme.colors.borderLight};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${theme.colors.cardHover};
  }
`;

const ProfileAvatar = styled.div`
  width: 32px;
  height: 32px;
  background: ${theme.colors.primaryGradient};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 14px;
`;

const ProfileInfo = styled.div`
  text-align: left;
`;

const ProfileName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.text.primary};
`;

const ProfileRole = styled.div`
  font-size: 12px;
  color: ${theme.colors.text.muted};
`;

const Header = ({ title, breadcrumbs }) => {
  // const [searchQuery, setSearchQuery] = useState('');

  return (
    <HeaderContainer
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <HeaderContent>
        <HeaderLeft>
          {breadcrumbs && (
            <Breadcrumb>
              {breadcrumbs.map((crumb, index) => (
                <React.Fragment key={index}>
                  {index === breadcrumbs.length - 1 ? (
                    <BreadcrumbActive>{crumb}</BreadcrumbActive>
                  ) : (
                    <BreadcrumbItem>{crumb}</BreadcrumbItem>
                  )}
                </React.Fragment>
              ))}
            </Breadcrumb>
          )}
          {/* <SearchContainer>
            <SearchIcon>
              <Search size={18} />
            </SearchIcon>
            <SearchInput
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </SearchContainer> */}
        </HeaderLeft>

        <HeaderRight>
          <IconButton>
            <Bell size={20} />
            <NotificationBadge />
          </IconButton>
          
          <ProfileButton>
            <ProfileAvatar>A</ProfileAvatar>
            <ProfileInfo>
              <ProfileName>Admin</ProfileName>
              <ProfileRole>Administrator</ProfileRole>
            </ProfileInfo>
            <ChevronDown size={16} color={theme.colors.text.muted} />
          </ProfileButton>
        </HeaderRight>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;
